/**
 * PartAndAccessories Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: PartAndAccessories for SEO pages
 */

/**
 * PartAndAccessories Component for SEO pages
 */

import React, { useCallback, useContext } from 'react'
import seoIds from '../../../../config/seoIds'
import { LocalContext } from '../../../helpers/useLocalContext'
import LinkMiddleware from '../../seo/LinkMiddleware'

import PartDisplay from './PartDisplay'

import {
  IImageTextOnlyProps,
  IPartAndAccessoriesCardProps,
} from './types'

const ImageTextOnly = (props: IImageTextOnlyProps) => {
  const {
    index,
    data,
    brandName,
    isBot,
    dualPartDisplay,
    onItemClick = () => {},
  } = props

  const {
    image,
    text,
    link,
    isNew,
  } = data

  const onClick = useCallback(() => onItemClick(), [onItemClick])

  return (
    <PartDisplay
      key={text}
      dualPartDisplay={dualPartDisplay}
      id={seoIds.partsAndAccessories.replace('{{key}}', index.toString())}
      elevation="small"
      alt={brandName ? `${brandName} ${text}` : text}
      isBot={isBot}
      imageSrc={image}
      imageText={text}
      Link={LinkMiddleware}
      to={link}
      isNew={isNew}
      cloudinaryParams="h_124,w_124"
      onItemClick={onClick}
    />
  )
}

export default function PartAndAccessoriesCard(props: IPartAndAccessoriesCardProps) {
  const {
    record,
    index,
    dualPartDisplay,
    brandName,
    onItemClick = () => {},
  } = props
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  const onClick = useCallback(() => onItemClick(), [onItemClick])

  return (
    <ImageTextOnly
      index={index}
      brandName={brandName}
      isBot={isBot}
      data={record}
      dualPartDisplay={dualPartDisplay}
      onItemClick={onClick}
    />
  )
}
